/**
 * @flow
 * @relayHash 1885aa2fdd63fe4959f3d80e139543a5
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type POUploadStatus = "CONFIRMED" | "FAILED" | "PROCESSING" | "READY_FOR_REVIEW";
export type POUploadSceneDetailQueryVariables = {|
  poUploadId: string
|};
export type POUploadSceneDetailQueryResponse = {|
  +poUpload: ?{|
    +poUploadId: string,
    +fileName: string,
    +fileUrl: string,
    +status: POUploadStatus,
    +errorMessage: ?string,
    +extractedData: ?any,
    +matchedData: ?any,
    +orderId: ?string,
    +createdAt: any,
  |}
|};
export type POUploadSceneDetailQuery = {|
  variables: POUploadSceneDetailQueryVariables,
  response: POUploadSceneDetailQueryResponse,
|};
*/


/*
query POUploadSceneDetailQuery(
  $poUploadId: ID!
) {
  poUpload(poUploadId: $poUploadId) {
    poUploadId
    fileName
    fileUrl
    status
    errorMessage
    extractedData
    matchedData
    orderId
    createdAt
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "poUploadId",
    "type": "ID!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "poUpload",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "poUploadId",
        "variableName": "poUploadId"
      }
    ],
    "concreteType": "POUpload",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "poUploadId",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "fileName",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "fileUrl",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "status",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "errorMessage",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "extractedData",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "matchedData",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "orderId",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "createdAt",
        "args": null,
        "storageKey": null
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "POUploadSceneDetailQuery",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "POUploadSceneDetailQuery",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "params": {
    "operationKind": "query",
    "name": "POUploadSceneDetailQuery",
    "id": null,
    "text": "query POUploadSceneDetailQuery(\n  $poUploadId: ID!\n) {\n  poUpload(poUploadId: $poUploadId) {\n    poUploadId\n    fileName\n    fileUrl\n    status\n    errorMessage\n    extractedData\n    matchedData\n    orderId\n    createdAt\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '451f73c422cd4face850ed9d36310149';
module.exports = node;
